const getDataAch = () => {
  return [
    {
      id: 28,
      name: "Mapres 1 FT Unila",
      event: "Pilmapres Unila",
      issuer: "University of Lampung",
      date: "Apr 2023",
    },
    {
      id: 27,
      name: "Keynote Speaker",
      event: "Webinar Frontend Development",
      issuer: "Sinauskill",
      date: "Mar 2023",
    },
    {
      id: 26,
      name: "Silver Medal",
      event: "Indonesian Olympiad (English)",
      issuer: "PT. Digital Edu Indonesia",
      date: "Mar 2023",
    },
    {
      id: 25,
      name: "Silver Medal",
      event: "Indonesian Olympiad (Biology)",
      issuer: "PT. Digital Edu Indonesia",
      date: "Mar 2023",
    },
    {
      id: 24,
      name: "Silver Medal",
      event: "Indonesian Olympiad (Economy)",
      issuer: "PT. Digital Edu Indonesia",
      date: "Mar 2023",
    },
    {
      id: 23,
      name: "Bronze Medal",
      event: "Indonesian Olympiad (Mathematics)",
      issuer: "PT. Digital Edu Indonesia",
      date: "Mar 2023",
    },
    {
      id: 22,
      name: "The Best Graduate",
      event: "Studi Independen 3",
      issuer: "Dicoding Indonesia",
      date: "Jan 2023",
    },
    {
      id: 1,
      name: "Outstanding Student",
      event: "Mahasiswa Berprestasi",
      issuer: "Universitas Lampung",
      date: "Dec 2022",
    },
    {
      id: 2,
      name: "1st Winner",
      event: "Smart Expo (National Essay)",
      issuer: "Politeknik Negeri Lampung",
      date: "Nov 2022",
    },
    {
      id: 3,
      name: "Keynote Speaker",
      event: "Webinar Kepenulisan Esai",
      issuer: "HMI Kom STAI, Kepulauan Riau",
      date: "Nov 2022",
    },
    {
      id: 4,
      name: "2nd Runner Up",
      event: "Chemistry Expo (National Essay)",
      issuer: "Himaki, Unila",
      date: "Oct 2022",
    },
    {
      id: 5,
      name: "Keynote Speaker",
      event: "Sharing Session Beasiswa",
      issuer: "Lab PBL, Unila",
      date: "Oct 2022",
    },
    {
      id: 6,
      name: "Fully Funded",
      event: "Inspiring Leader Camp",
      issuer: "Duta Inspirasi Indonesia",
      date: "Oct 2022",
    },
    {
      id: 7,
      name: "The Best Group FGD",
      event: "Inspiring Leader Camp",
      issuer: "Duta Inspirasi Indonesia",
      date: "Oct 2022",
    },
    {
      id: 8,
      name: "1st Winner",
      event: "Biofest (National Essay)",
      issuer: "Formandibula, Unila",
      date: "Sep 2022",
    },
    {
      id: 9,
      name: "2nd Runner Up",
      event: "Bimeneorty (National Essay)",
      issuer: "Teknik Biomedis, Itera",
      date: "Sep 2022",
    },
    {
      id: 10,
      name: "Duta Inspirasi",
      event: "Duta Inpirasi Indonesia",
      issuer: "Kemenpora",
      date: "Sep 2022",
    },
    {
      id: 11,
      name: "1st Winner",
      event: "Dinamika XXIII (National Essay)",
      issuer: "Himatika, Unila",
      date: "Jul 2022",
    },
    {
      id: 12,
      name: "2nd Runner Up",
      event: "Himatro Menulis",
      issuer: "Himatro, Unila",
      date: "Feb 2022",
    },
    {
      id: 13,
      name: "Awardee",
      event: "Beasiswa Unggulan",
      issuer: "Kemendikbud Ristek",
      date: "Nov 2021",
    },
    {
      id: 14,
      name: "1st Runner Up",
      event: "Pekan Raya  (National Essay)",
      issuer: "Himakom, Unila",
      date: "Oct 2021",
    },
    {
      id: 15,
      name: "Moderator",
      event: "Webinar Kewirausahaan (National)",
      issuer: "Himatro, Unila",
      date: "Oct 2021",
    },
    {
      id: 16,
      name: "Moderator",
      event: "Training Kewirausahaan",
      issuer: "Himatro, Unila",
      date: "Oct 2021",
    },
    {
      id: 17,
      name: "3rd Runner Up",
      event: "Love Comp (Scrabble Sumbagsel)",
      issuer: "English Society, Unila",
      date: "Sep 2019",
    },
    {
      id: 18,
      name: "1st Runner Up",
      event: "Taekwondo Champions (Province)",
      issuer: "Laskar Taekwondo Club",
      date: "Apr 2019",
    },
    {
      id: 19,
      name: "Outstanding Student",
      event: "Mahasiwa Berprestasi",
      issuer: "SMAN 5 Bandar Lampung",
      date: "Apr 2019",
    },
    {
      id: 20,
      name: "1st Winner",
      event: "Bulan Bahasa (Scrabble)",
      issuer: "SMAN 5 Bandar Lampung",
      date: "Oct 2018",
    },
    {
      id: 21,
      name: "1st Runner Up",
      event: "Diesnatalis (Province Scrabble)",
      issuer: "Akbid Adila",
      date: "Aug 2018",
    },
  ];
};

export { getDataAch };
